import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../../course/components/sectionTitle';
import Conversation from './conversation';
import Animation001 from './animation001';
import Animation004 from './animation004';
import Animation009 from './animation009';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Quiz from '../../components/quiz';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation001,
  Animation004,
  Animation009,
  Component002,
  Component003,
  Component004,
};

export default Components;
